import React, { Fragment } from "react";
import { Parallax } from "react-scroll-parallax";
import { ReactSVG } from "react-svg";
import Media from "react-media";
import { MOBILE_WIDTH } from "../../constants";
import Showcase from "../common/Showcase";
import tallSpiral from "../../assets/shapes/tallSpiral.svg";
import rightBottomArrowPat from "../../assets/shapes/rightBottomArrowPat.svg";

import styles from "./Pattern.module.scss";
import imageSource from '../../assets/screenshots/2-patternForm.png';

const pattern = {
  title: "Patterns",
  content:
    "These are the pattens that you will hold yourself accountable to in order to achieve your goal.",
  featureTitle: "Features",
  features: [
    "Flexible notifications allow you to remind / warn yourself of what needs done at strategic times in the day.",
    "Adjustable motivational fee tied to each pattern helps hold you accountable."
  ],
  imageSource,
};

const Pattern = props => {
  const {
    centerCluster,
    centerStyle,
    center,
    centerSM,
    border,
    primaryGreen,
    primaryRed,
    top,
    bottom
  } = styles;
  return (
    <Fragment>
      <Showcase item={pattern} bubbleStyle={border}>
        <Parallax translateX={[-30, 30]} className={top}>
          <ReactSVG src={rightBottomArrowPat} style={{ fill: primaryRed }} />
        </Parallax>

        <div className={centerCluster}>
          <Parallax translateY={[100, -100]} className={centerStyle}>
            <Media query={{ maxWidth: MOBILE_WIDTH }}>
              {matches => (
                <ReactSVG
                  src={tallSpiral}
                  className={`${matches ? centerSM : center}`}
                />
              )}
            </Media>
          </Parallax>
        </div>

        <Parallax translateX={[30, -30]} className={bottom}>
          <ReactSVG src={rightBottomArrowPat} style={{ fill: primaryGreen }} />
        </Parallax>
      </Showcase>
    </Fragment>
  );
};

export default Pattern;
